export default "__VITE_ASSET__DBwjNsFw__"